import { useMutation, useQueryClient } from '@tanstack/react-query';
import client from '../client';

export type SendOpenItemBatchInput = {
  grantId: string;
  taxYear: number;
  openItemIds: string[];
  expectedVersions: number[];
  messages: string[];
  idempotencyKey: string;
};

export function useSendOpenItemBatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ grantId, taxYear, openItemIds, expectedVersions, messages, idempotencyKey }: SendOpenItemBatchInput) => {
      const response = await client.post(`/api/accountant/clients/${grantId}/years/${taxYear}/open-item-batches/send`, {
        open_item_ids: openItemIds,
        expected_versions: expectedVersions,
        messages,
        idempotency_key: idempotencyKey,
      });
      return response.data;
    },
    onSuccess: (_data, input) => {
      void queryClient.invalidateQueries({ queryKey: ['accountant-open-items', input.grantId, input.taxYear] });
    },
  });
}

